var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("从业信息")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("从业信息"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "手机号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入手机号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "phone", $$v)
                                    },
                                    expression: "ruleForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建时间" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        placeholder: "选择开始时间",
                                        align: "right",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                      },
                                      model: {
                                        value: _vm.ruleForm.time,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "time", $$v)
                                        },
                                        expression: "ruleForm.time",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { margin: "0 5px" } },
                                      [_vm._v("-")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        placeholder: "选择结束时间",
                                        align: "right",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                      },
                                      model: {
                                        value: _vm.ruleForm.time1,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "time1", $$v)
                                        },
                                        expression: "ruleForm.time1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "未申报", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已申报", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.InvoicingAll()
                      },
                    },
                  },
                  [_vm._v("批量申报")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.exportList()
                      },
                    },
                  },
                  [_vm._v("导出申报excel")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("TableScrollSlider", {
              attrs: { "table-ref": _vm.$refs.multipleTable },
            }),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "cardName", label: "姓名", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cardTypeName",
                    label: "证件类型",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cardCode",
                    label: "证件编号",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "nation", label: "国籍", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "sexName", label: "性别", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "birthday",
                    label: "出生日期",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "employType",
                    label: "任职受雇从业类型",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "phone", label: "手机号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "任职受雇从业日期",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "position", label: "职务", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isDeclare == 0
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("未申报"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.isDeclare == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已申报"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "创建时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isDeclare == 0
                            ? _c("div", { staticClass: "disAround" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.Invoicing(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                提交申报\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [20, 30, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible1,
            width: "40%",
            "before-close": _vm.handleClose1,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "350px", "overflow-y": "scroll" } },
            _vm._l(_vm.errorList, function (item, index) {
              return _c("div", { key: index }, [_vm._v(_vm._s(item))])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible1 = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }